module.exports = __webpack_public_path__ + "assets/img/logo_hippo.662c126f.png";